import React from "react";
import { Row, Col, BodyText } from "shared-portal-component";

import '@/components/molecules/ActivityHeader/ActivityHeader.scss';
import ActivityTextComponent from "@/components/atomic/ActivityTextComponent/ActivityTextComponent";

interface ActivityHeaderRowProps {
  title: string;
  time: string;
}

const ActivityHeaderRow: React.FC<ActivityHeaderRowProps> = ({
  title,
  time,
}) => (
    <Row spacing="md" align="center" justify="between"  className="activity-header-row">
      {/* Left section */}
      <Col>
        <Row spacing="md" align="center" wrap="nowrap">
          <BodyText as="span" className={`activity-dot activity-dot--teal mr-4`} />
          <BodyText as="span" className="activity-title">
            {title}
          </BodyText>
        </Row>
      </Col>
      {/* Right section (time) */}
      <Col size="content">
        <ActivityTextComponent> {time}</ActivityTextComponent>
      </Col>
    </Row>
);

export default ActivityHeaderRow;
